<template>
  <div class="border_box">
    <div
      class="errmsg-box border_box"
      v-if="errmsg === 20010 || errmsg === 20011"
    >
      <img src="../../assets/images/fixedstatementerror/tips.png" alt="" />
      <div class="tips-box border_box">
        <p>您的账号已停用</p>
        <p>请联系您的销售顾问<span>及时续约</span></p>
      </div>
    </div>
    <div class="errmsg-box border_box" v-else-if="errmsg === 20012">
      <img src="../../assets/images/fixedstatementerror/tips.png" alt="" />
      <div class="tips-box border_box">
        <p>您的账号已弃用</p>
        <p>请联系您的销售顾问<span>及时续约</span></p>
      </div>
    </div>
    <div
      class="errmsg-box border_box"
      v-else-if="errmsg === 20013 || errmsg === 20017"
    >
      <img src="../../assets/images/fixedstatementerror/tips.png" alt="" />
      <div class="tips-box border_box">
        <p>请扫码绑定网媒账号对应的预警推送公众号后</p>
        <p>重新打开查看</p>
      </div>
    </div>
    <div class="errmsg-box border_box" v-else-if="errmsg === 20016">
      <img src="../../assets/images/fixedstatementerror/tips.png" alt="" />
      <div class="tips-box border_box">
        <p>系统链接暂不支持分享查看</p>
        <p>如需分享请复制分享原文链接</p>
      </div>
    </div>
    <template v-else>
      <template v-if="infoErrMsg === 10404">
        <div class="errmsg-box border_box">
          <img src="../../assets/images/fixedstatementerror/tips.png" alt="" />
          <div class="tips-box border_box">
            <p>不支持查看在网媒系统中已删除的信息</p>
          </div>
        </div>
      </template>
      <template v-else>
        <div
          class="fixed-error-box border_box"
          v-if="!loading && Object.keys(resObj).length"
        >
          <div class="fixed-content-box border_box">
            <div
              class="fixed-title-box border_box ellipsis-2"
              v-html="articleTitle"
            ></div>
            <div class="fixed-info-box border_box flex_verticle ellipsis">
              <span class="txt time">{{ resObj.publishTimeTxt }}</span>
              <span class="txt ellipsis">{{ resObj.siteName }}</span>
              <template v-if="resObj.siteType !== '11'">
                <span class="txt type" v-if="resObj.siteType === '01'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/wz.png"
                  />{{ resObj.siteTypeName }}</span
                >
                <span class="txt type" v-if="resObj.siteType === '04'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/wb.png"
                  />{{ resObj.siteTypeName }}</span
                >
                <span class="txt type" v-if="resObj.siteType === '06'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/wx.png"
                  />{{ resObj.siteTypeName }}</span
                >
                <span class="txt type" v-if="resObj.siteType === '12'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/tt.png"
                  />{{ resObj.siteTypeName }}</span
                >
                <span class="txt type" v-if="resObj.siteType === '13'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/tb.png"
                  />{{ resObj.siteTypeName }}</span
                >
                <span class="txt type" v-if="resObj.siteType === '14'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/bjh.png"
                  />{{ resObj.siteTypeName }}</span
                >
                <span class="txt type" v-if="resObj.siteType === '15'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/ty.png"
                  />{{ resObj.siteTypeName }}</span
                >
                <span class="txt type" v-if="resObj.siteType === '16'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/wy.png"
                  />{{ resObj.siteTypeName }}</span
                >
                <span class="txt type" v-if="resObj.siteType === '17'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/qq.png"
                  />{{ resObj.siteTypeName }}</span
                >
                <span class="txt type" v-if="resObj.siteType === '18'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/sh.png"
                  />{{ resObj.siteTypeName }}</span
                >
                <span class="txt type" v-if="resObj.siteType === '19'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/dfh.png"
                  />{{ resObj.siteTypeName }}</span
                >
              </template>
              <template v-if="resObj.siteType === '11'">
                <span class="txt type" v-if="resObj.videoType === '01'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/dy.png"
                  />{{ resObj.videoTypeName }}</span
                >
                <span class="txt type" v-if="resObj.videoType === '02'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/ks.png"
                  />{{ resObj.videoTypeName }}</span
                >
                <span class="txt type" v-if="resObj.videoType === '03'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/xg.png"
                  />{{ resObj.videoTypeName }}</span
                >
                <span class="txt type" v-if="resObj.videoType === '04'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/xhs.png"
                  />{{ resObj.videoTypeName }}</span
                >
                <span class="txt type" v-if="resObj.videoType === '05'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/dyh.png"
                  />{{ resObj.videoTypeName }}</span
                >
                <span class="txt type" v-if="resObj.videoType === '06'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/mp.png"
                  />{{ resObj.videoTypeName }}</span
                >
                <span class="txt type" v-if="resObj.videoType === '07'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/dxs.png"
                  />{{ resObj.videoTypeName }}</span
                >
                <span class="txt type" v-if="resObj.videoType === '08'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/ws.png"
                  />{{ resObj.videoTypeName }}</span
                >
                <span class="txt type" v-if="resObj.videoType === '09'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/bili.png"
                  />{{ resObj.videoTypeName }}</span
                >
                <span class="txt type" v-if="resObj.videoType === '10'"
                  ><img
                    src="../../assets/images/fixedstatementerror/icon/hk.png"
                  />{{ resObj.videoTypeName }}</span
                >
              </template>
            </div>
            <div class="list-content-box border_box">
              <div
                class="list-box border_box"
                :class="i > 1 ? getClass : ''"
                v-for="(list, i) of searchProblemWordArr"
                :key="'list' + i"
                @click.stop="
                  list.id === 'wordlist' ? positionAct(list) : positioning(list)
                "
              >
                <span class="level level-1" v-if="list.errorLevel === '1'"
                  >轻微</span
                >
                <span class="level level-2" v-else-if="list.errorLevel === '2'"
                  >一般</span
                >
                <span class="level level-3" v-else-if="list.errorLevel === '3'"
                  >严重</span
                >
                <span class="errtxt">{{ list.problemWord }}</span>
                <span class="arrow"
                  ><img src="../../assets/images/fixedstatementerror/arrow.png"
                /></span>
                <span class="cretxt">{{ list.recommendWord }}</span>
              </div>
            </div>
            <div
              class="ops-open border_box"
              v-if="searchProblemWordArr.length > 2"
            >
              <span
                :class="!isOpen ? 'open-btn' : 'hide-btn'"
                @click.stop="openList(isOpen)"
                >{{ !isOpen ? "展开" : "收起" }}</span
              >
            </div>
            <div
              class="video-box border_box"
              v-if="resObj.siteType === '11' && !!resObj.videoUrl"
            >
              <video
                :src="resObj.videoUrl"
                loop="loop"
                controls
                width="100%"
                height="100%"
              >
                您的浏览器不支持 video 标签。
              </video>
            </div>
            <div class="fixed-content border_box" v-html="articleContent"></div>
            <div>
              <div class="attachment">
                <div class="ocr-detail" v-if="ocrMessages.length > 0">
                  <!-- 固定表述错误类似，有ocr识别标识，显示 -->
                  <div>
                    <div
                      v-for="(item, index) in ocrMessages"
                      :key="'ocr' + index"
                      class="ocr-warp"
                    >
                      <img
                        :src="item.originalUrl"
                        alt=""
                        @error.once="(event) => (event.target.src = item.url)"
                      />
                      <p>
                        <span class="ocr-icon">OCR</span>
                        <span v-html="item.content"></span>
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="attachment-box"
                  v-if="attMessages.length > 0 && userType === 2"
                >
                  <span class="attachment-title">文章附件</span
                  ><img
                    class="attachment-img"
                    src="../../assets/images/fixedstatementerror/attachment.svg"
                  />
                </div>
                <div
                  class="attachment-list-box"
                  v-if="attMessages.length > 0 && userType === 2"
                >
                  <ul>
                    <li
                      class="attachment-item-box"
                      v-for="(item, index) in attMessages"
                      :key="index"
                    >
                      <div class="attachment-name">{{ item.name }}</div>
                      <div
                        class="attachment-tip"
                        v-show="item.words.length === 0"
                      >
                        附件中未识别出固定表述错误
                      </div>
                      <div
                        class="attachment-error-box"
                        v-show="item.words.length > 0"
                      >
                        <ul>
                          <li
                            class="attachment-error-item-box"
                            v-for="(item, index) in item.words"
                            :key="index"
                          >
                            <span v-html="item.context"></span>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="attachment" v-if="userType === 1 && attSign === 2">
                <div class="attachment-box">
                  <span class="attachment-title">附件巡查</span>
                </div>
                <div class="inspection">
                  <img
                    src="../../assets/images/fixedstatementerror/inspection.svg"
                    alt=""
                  />
                </div>
                <div class="no-vip">附件巡查仅正式用户可用</div>
                <div class="no-vip">请联系商务人员，升级体验完整功能</div>
              </div>
            </div>
          </div>
          <!-- 灰块 -->
          <div
            class="block-box border_box"
            v-if="resObj.siteType === '11'"
          ></div>
          <!-- 小视频用户信息 -->
          <div class="user-info-box border_box" v-if="resObj.siteType === '11'">
            <div class="user-top-box border_box flex-verticle">
              <div class="head-box border_box">
                <img
                  :src="
                    userInfo.profile_img_url
                      ? userInfo.profile_img_url
                      : userIcon
                  "
                  alt=""
                />
              </div>
              <div class="head-content-box border_box flex_1 ellipsis">
                <div class="user-name-box border_box flex-verticle">
                  <span class="name">{{ userInfo.name }}</span>
                  <!-- //是否认证 1=橙V 2=蓝V 0=未认证 “”=未认证 null=未认证 -->
                  <span
                    class="vlog"
                    v-show="
                      Object.keys(resObj.user).length &&
                      (resObj.user.verified === 1 || resObj.user.verified === 2)
                    "
                  ></span>
                </div>
                <div class="user-infos-box border_box flex">
                  <p class="info-list border_box ellipsis">
                    <span class="infos-txt">粉丝：</span>
                    <span class="infos-value">{{
                      userInfo.followers_count ? userInfo.followers_count : "-"
                    }}</span>
                  </p>
                  <!-- <p class="info-list border_box ellipsis">
                    <span class="infos-txt">关注：</span>
                    <span class="infos-value">123456</span>
                  </p>
                  <p class="info-list border_box ellipsis">
                    <span class="infos-txt">获赞：</span>
                    <span class="infos-value">123456</span>
                  </p>
                  <p class="info-list border_box ellipsis">
                    <span class="infos-txt">转发：</span>
                    <span class="infos-value">123456</span>
                  </p> -->
                </div>
              </div>
            </div>
            <div class="user-btom-box border_box">
              <div class="list-info border_box flex-verticle">
                <span class="icon icon01"></span>
                <div class="txt flex_1">
                  媒体类型：<span>{{
                    resObj.mediaType ? resObj.mediaType : "暂无"
                  }}</span>
                </div>
              </div>
              <div class="list-info border_box flex-verticle">
                <span class="icon icon05"></span>
                <div class="txt flex_1">
                  作者ID：<span>{{
                    userInfo.uid ? userInfo.uid : "暂无"
                  }}</span>
                </div>
              </div>
              <div class="list-info border_box flex-verticle">
                <span class="icon icon02"></span>
                <div class="txt flex_1">
                  认证描述：<span>{{
                    userInfo.verified_reason ? userInfo.verified_reason : "暂无"
                  }}</span>
                </div>
              </div>
              <div class="list-info border_box flex-verticle">
                <span class="icon icon03"></span>
                <div class="txt flex_1">
                  注册地：<span>{{
                    userInfo.location ? userInfo.location : "暂无"
                  }}</span>
                </div>
              </div>
              <div class="list-info border_box flex-verticle">
                <span class="icon icon04"></span>
                <div class="txt flex_1">
                  IP属地：<span>{{
                    userInfo.ip_region ? userInfo.ip_region : "暂无"
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="ops-btn-box border_box">
            <span class="ops-btn" @click.stop="copyInfo(resObj)">复制</span>
            <a class="ops-btn" :href="resObj.url">查看原文</a>
          </div> -->
          <div
            class="ops-btn-box border_box flex-verticle-right"
            v-clickoutside="closeMask"
          >
            <!-- 待处置展示两个按钮 -->
            <template v-if="resObj.handleStatus === 1">
              <div class="ops-item-box item-01">
                <span class="ops-btn" @click.stop="ignoreInfo()">忽略</span>
                <div class="mask-wrap-box border_box" v-show="isShowIgnore">
                  <div
                    class="mask-item-box border_box"
                    v-for="(ignore, d) of ignoreArr"
                    :key="'ignore' + d"
                    :class="activeIgnore === ignore.value ? 'active' : ''"
                    @click.stop="ignoreHandler(ignore)"
                  >
                    {{ ignore.label }}
                  </div>
                </div>
              </div>
              <div class="ops-item-box item-02">
                <span class="ops-btn" @click.stop="disposeInfo()">处置</span>
                <div class="mask-wrap-box border_box" v-show="isShowDispose">
                  <div
                    class="mask-item-box border_box"
                    v-for="(dispose, d) of disposeArr"
                    :key="'dispose' + d"
                    :class="activeDispose === dispose.value ? 'active' : ''"
                    @click.stop="disposeHandler(dispose)"
                  >
                    {{ dispose.label }}
                  </div>
                </div>
              </div>
            </template>
            <span class="ops-btn" @click.stop="copyInfo(resObj)">复制</span>
            <a class="ops-btn" :href="resObj.url">查看原文</a>
          </div>
        </div>
        <template v-if="!loading && Object.keys(resObj).length === 0">
          <div class="nodata-box">
            <p>暂无数据</p>
          </div>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
let moment = require("moment");
import { Toast } from "vant";
import Clickoutside from "@/directives/clickoutside";
import { getInfos, getCode, handleViolation } from "@/api/fixedstatementerror";
export default {
  name: "fixedStatementError",
  directives: {
    Clickoutside,
  },
  data() {
    return {
      userInfo: "", // 用户信息
      userType: null, // 用户类型
      ocrMessages: [], // ocr识别结果
      attMessages: [], // 附件信息
      attSign: 0, // 附件未识别
      userIcon: require("../../assets/images/fixedstatementerror/user_img.png"),
      loading: false,
      isOpen: false,
      resObj: {},
      errmsg: 0, // 错误信息值 200无错
      isShowIgnore: false,
      activeIgnore: "",
      ignoreArr: [
        // 忽略操作项
        { value: 10, label: "系统判定有误" },
        { value: 11, label: "非本地市信息" },
        { value: 12, label: "其他原因" },
      ],
      isShowDispose: false,
      activeDispose: "",
      disposeArr: [
        // 处置操作项
        { value: 4, label: "已约谈整改" },
        { value: 5, label: "已上报线索" },
        { value: 6, label: "已关停站点" },
        { value: 7, label: "已更正" },
        { value: 8, label: "已转交" },
        { value: 21, label: "已删除" },
        { value: 9, label: "其他处置方式" },
      ],
      searchProblemWordArr: [],
      infoErrMsg: 0, // 10404 不支持查看在网媒系统中已删除的信息
      articleTitle: '', // 文章显示的标题（会有标黄的可能）
      articleContent: '', // 文章显示的内容（会有标黄的可能）
    };
  },
  beforeCreate() {
    console.log('[FSE][beforeCreate] 触发', new Date().toISOString());
  },
  created() {
    console.log('[FSE][created] 页面created触发', new Date().toISOString());
    // 固定表述错误页面，更改网页ico
    let pageUrl = this.$route.path;
    if (pageUrl === "/fixedstatementerror") {
      document.querySelector("link.linkico").href = "./wmico.ico";
    } else {
      document.querySelector("link.linkico").href = "./favicon.ico";
    }
  },
  computed: {
    getClass() {
      let val = this.isOpen ? "" : "hide";
      return val;
    },
  },
  beforeMount() {
    console.log('[FSE][beforeMount] 触发', new Date().toISOString());
  },
  mounted() {
    const hasToken = !!localStorage.getItem("wlgl-token");
    const hasQuery = Object.keys(this.$route.query).length > 0;
    console.log('[FSE][mounted] 页面mounted触发', new Date().toISOString(), { hasToken, hasQuery, query: this.$route.query });
    if (hasToken) {
      console.log('[FSE][mounted] 已有token，直接queryInfos');
      this.queryInfos(2);
    } else if (!hasToken && !hasQuery) {
      console.log('[FSE][mounted] 无token且无query参数，设置errmsg=20016（不支持分享查看）');
      this.errmsg = 20016;
    } else {
      console.log('[FSE][mounted] 无token但有query参数，走微信OAuth换token流程');
      this.init();
    }
  },
  beforeUpdate() {
    console.log('[FSE][beforeUpdate] 触发', new Date().toISOString());
  },
  updated() {
    console.log('[FSE][updated] 触发', new Date().toISOString());
  },
  beforeDestroy() {
    console.log('[FSE][beforeDestroy] 触发', new Date().toISOString());
  },
  methods: {
    init() {
      if (Object.keys(this.$route.query).length) {
        const code = this.$route.query.code;
        const state = this.$route.query.state;
        this.queryCode(code, state);
      }
    },
    // 获取 wlgl-token
    queryCode(code, state) {
      console.log('[FSE][queryCode] 开始换取token', new Date().toISOString(), { code: code ? code.slice(0, 8) + '...' : null, state });
      const t0 = Date.now();
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getCode({
        code: code,
        state: state,
      })
        .then((res) => {
          const cost = Date.now() - t0;
          if (res.data.code === 200) {
            console.log('[FSE][queryCode] 换取token成功', new Date().toISOString(), { cost: cost + 'ms' });
            localStorage.setItem("wlgl-token", res.data.data);
            this.queryInfos(1);
          } else {
            console.log('[FSE][queryCode] 换取token失败', new Date().toISOString(), { cost: cost + 'ms', code: res.data.code });
            this.errmsg = res.data.code;
          }
        })
        .catch((err) => {
          const cost = Date.now() - t0;
          console.log('[FSE][queryCode] 换取token异常', new Date().toISOString(), { cost: cost + 'ms', err: err && err.message });
          Toast.clear();
          console.log(err);
        });
    },
    openList(isOpen) {
      this.isOpen = !isOpen;
    },
    queryStatus() {
      const routeQuery =
        this.$route && this.$route.query ? this.$route.query : {};
      let state = routeQuery.state;
      const stateStr = String(state);
      if (stateStr.includes("_")) {
        const statusArr = stateStr.split("_");
        return statusArr[0];
      }
      return stateStr;
    },
    queryInfos(num) {
      console.log('[FSE][queryInfos] 开始请求文章数据', new Date().toISOString(), { num, from: num === 1 ? '换token后调用' : '直接调用(已有token)' });
      const t0 = Date.now();
      if (num === 2) {
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        this.loading = true;
      }
      this.userInfo = "";
      this.searchProblemWordArr = [];
      this.infoErrMsg = 0;
      const status = this.queryStatus();
      getInfos({
        state: status,
      })
        .then((res) => {
          // 网络耗时：从发起请求(t0)到拿到响应
          const _tNet = Date.now();
          console.log(
            `[FSE][queryInfos] 接口返回, 网络请求耗时=${_tNet - t0}ms, code=${
              res.data.code
            }, 响应体大小≈${JSON.stringify(res.data).length}`
          );
          // 10404  不支持查看在网媒系统中已删除的信息
          this.infoErrMsg = res.data.code;
          if (res.data.code === 200) {
            const { userType, attMessages, ocrMessages, attSign } =
              res.data.data;
            (this.attMessages = attMessages || []),
              (this.ocrMessages = ocrMessages || []),
              (this.attSign = attSign);
            this.userType = userType;
            Toast.clear();
            this.loading = false;
            console.log('[FSE][queryInfos] loading=false，页面开始渲染', new Date().toISOString());
            this.resObj = res.data.data;
            this.resObj.copyTitle = JSON.parse(
              JSON.stringify(this.resObj.title)
            );
            if (Object.keys(res.data.data).length) {
              this.resObj.publishTimeTxt = res.data.data.publishTime
                ? moment(res.data.data.publishTime).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                : "";
              this.resObj.publishTimestamp = res.data.data.publishTimestamp
                ? moment(res.data.data.publishTimestamp).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                : "";
              this.userInfo = res.data.data.user ? res.data.data.user : "";
              if (this.userInfo) {
                this.userInfo.location =
                  this.userInfo.location && this.userInfo.location.length != 0
                    ? this.userInfo.location.join("/")
                    : "暂无";
                this.userInfo.ip_region =
                  this.userInfo.ip_region && this.userInfo.ip_region.length != 0
                    ? this.userInfo.ip_region.join("/")
                    : "暂无";
              }
              // 媒体类型
              if (this.resObj.siteType === "11") {
                this.resObj.mediaType = this.resObj.videoTypeName;
              } else {
                this.resObj.mediaType = this.resObj.siteTypeName;
              }
              const flag = this.mergeIntervals(
                this.resObj.wordList
              ).isOverlapping;

              /**
               * 数据兼容处理：
               * 判断 item 中是否包含 firstLevelName 和 secondLevelName 这两个属性。
               * 如果这两个属性存在且不是空字符串，则取其值；如果不存在或者为空，则赋值为空字符串
               *
               */
              // 标黄处理
              for (let i = 0; i < res.data.data.wordList.length; i++) {
                let item = res.data.data.wordList[i];
                this.searchProblemWordArr.push({
                  errorLevel: item.errorLevel,
                  problemWord: item.problemWord,
                  recommendWord: item.recommendWord,
                  length: item.problemWord.length,
                  start: item.start * 1,
                  // id: flag ? "wordlist" : `wordList${i}`,
                  id: "wordlist",
                  firstLevelName:
                    Object.keys(item).includes("firstLevelName") &&
                    item.firstLevelName !== ""
                      ? item.firstLevelName
                      : "",
                  secondLevelName:
                    Object.keys(item).includes("secondLevelName") &&
                    item.secondLevelName !== ""
                      ? item.secondLevelName
                      : "",
                });
                // 按照字符串长度倒叙排
                //this.searchProblemWordArr = this.searchProblemWordArr.sort(this.compare("length"))
              }
              this.ocrMessages.forEach((item, index0) => {
                let arr1 = [...item.content],
                  arr2 = Array(item.content.length).fill(false);
                item.words.forEach((word, index1) => {
                  word.id = `${index0}ocrMessages${index1}`;
                  this.searchProblemWordArr.push({
                    errorLevel: word.errorLevel,
                    problemWord: word.problemWord,
                    recommendWord: word.recommendWord,
                    length: word.problemWord.length,
                    start: word.start,
                    id: word.id,
                    firstLevelName:
                      Object.keys(word).includes("firstLevelName") &&
                      word.firstLevelName !== ""
                        ? word.firstLevelName
                        : "",
                    secondLevelName:
                      Object.keys(word).includes("secondLevelName") &&
                      word.secondLevelName !== ""
                        ? word.secondLevelName
                        : "",
                  });
                  this.setTrueInRange(arr2, word.start, word.end, word.id);
                });
                arr2.forEach((item, index) => {
                  if (item) {
                    arr1[
                      index
                    ] = `<span id=red_word_${item[1]} class="mark">${arr1[index]}</span>`;
                  }
                });
                item.content = arr1.join("");
                arr1 = null;
                arr2 = null;
              });
              this.attMessages.forEach((item, index0) => {
                item.words.forEach((word, index1) => {
                  word.id = `${index0}attMessages${index1}`;
                  if (this.userType === 2) {
                    this.searchProblemWordArr.push({
                      errorLevel: word.errorLevel,
                      problemWord: word.problemWord,
                      recommendWord: word.recommendWord,
                      length: word.problemWord.length,
                      start: word.start,
                      id: word.id,
                      firstLevelName:
                        Object.keys(word).includes("firstLevelName") &&
                        word.firstLevelName !== ""
                          ? word.firstLevelName
                          : "",
                      secondLevelName:
                        Object.keys(word).includes("secondLevelName") &&
                        word.secondLevelName !== ""
                          ? word.secondLevelName
                          : "",
                    });
                  }
                  let arr1 = [...word.context],
                    arr2 = Array(word.context.length).fill(false);
                  this.setTrueInRange(arr2, word.start, word.end, word.id);
                  arr2.forEach((item, index) => {
                    if (item) {
                      arr1[
                        index
                      ] = `<span id=red_word_${item[1]} class="mark">${arr1[index]}</span>`;
                    }
                  });
                  word.context = arr1.join("");
                  arr1 = null;
                  arr2 = null;
                });
              });
              if (
                this.attMessages &&
                this.attSign === 2 &&
                this.userType === 1
              ) {
                this.searchProblemWordArr.push({
                  problemWord: "附件含错词",
                  recommendWord: "附件含推荐词",
                });
              }
              if (flag) {
                // console.log("重叠");
                this.handlerTitleOrContent(this.resObj);
              } else {
                // console.log('无重叠')
                this.markYellowNew(this.resObj);
              }
              // for(let j = 0; j < this.searchProblemWordArr.length; j++){
              //   let item = this.searchProblemWordArr[j]
              //   const replaceStr =
              //     '<span class="mark" id="red_word_' +
              //     j +
              //     '">' +
              //     item.problemWord +
              //     "</span>";
              //     let record = {
              //       title: this.resObj.title,
              //       redKeyWord: item.problemWord,
              //       originContent: this.resObj.content
              //     };
              //     let markContent = this.yellowLabelReminder(record, replaceStr)
              //     this.resObj.content = markContent.originContent;
              //     this.resObj.title = markContent.title;
              // }
            }
            // 处理耗时：标黄等同步计算完成后的时间点（主线程阻塞时长）
            const _tProc = Date.now();
            console.log(
              `[固定表述详情] 前端处理(标黄等)耗时=${_tProc - _tNet}ms, 标题长度=${
                this.resObj.title ? this.resObj.title.length : 0
              }, 正文长度=${this.resObj.content ? this.resObj.content.length : 0}`
            );
            // 渲染耗时：v-html 等 DOM 渲染完成（白屏消失时间点）
            this.$nextTick(() => {
              console.log(
                `[固定表述详情] DOM渲染耗时=${Date.now() - _tProc}ms, 首屏总耗时≈${
                  Date.now() - t0
                }ms`
              );
            });
          } else if (res.data.code === 20009) {
            console.log('[FSE][queryInfos] token失效(20009)，重新走OAuth', new Date().toISOString());
            Toast.clear();
            this.loading = false;
            this.resObj = {};
            this.allData = [];
            this.listData = [];
            this.userInfo = "";
            this.searchProblemWordArr = [];
            // token 失效
            this.init();
          } else {
            console.log('[FSE][queryInfos] 接口返回异常code', new Date().toISOString(), { code: res.data.code });
            Toast.clear();
            this.loading = false;
            this.resObj = {};
            this.allData = [];
            this.listData = [];
            this.userInfo = "";
            this.searchProblemWordArr = [];
          }
        })
        .catch((err) => {
          console.log('[FSE][queryInfos] 请求异常', new Date().toISOString(), { err: err && err.message });
          Toast.clear();
          console.log(err);
        });
    },
    copyInfo(info) {
      this.closeMask();
      Toast.loading({
        message: "复制中...",
        forbidClick: true,
        loadingType: "spinner",
      });

      // 错敏分类，复制时数据处理，// 如果 secondLevelName 为空，使用 firstLevelName，若firstLevelName和若secondLevelName的值为空都为空，不取
      const errorClassifyTxt = this.searchProblemWordArr
        .map((item) => item.secondLevelName || item.firstLevelName)
        .filter((level) => level)
        .join(", ");
      let content = "";
      content += "文章标题：" + info.copyTitle + "\n";
      content += "原文链接：" + info.url + "\n";
      content += "错敏分类：" + errorClassifyTxt + "\n";
      content += "错敏词：" + info.copyProblemWord + "\n";
      content += "推荐修改词：" + info.copyRecommendWord + "\n";
      content += "所在上下文：" + info.copyContext + "\n";
      content += "发布时间：" + info.publishTimestamp + "\n";
      content += "媒体类型：" + info.mediaType + "\n";
      content += "信源名称：" + info.siteName;
      this.copy(content);
    },
    copy(copycontent) {
      if (!copycontent) {
        return Toast.fail("暂无复制内容");
      }
      const clipboard = document.createElement("textarea");
      clipboard.value = copycontent;
      document.body.appendChild(clipboard);
      clipboard.select(); // 选择对象
      document.execCommand("Copy", false, true); // 执行浏览器复制命令
      clipboard.remove();
      setTimeout(function () {
        Toast.success({
          message: "复制成功",
        });
      }, 500);
    },
    // ..............
    // markTag(arr, text, itemdata) {
    //   let resultStr = ""; // 处理后，页面展示的dom字符串
    //   const strArr = []; // 未标黄的字符串截取的片段
    //   const replaceArr = []; // 替换后dom的数组
    //   // 下标计算
    //   let indexTemp = 0;
    //   arr.map((item, index) => {
    //     // item.startCopy = JSON.parse(JSON.stringify(item.start))
    //     item.id = `wordList${index}`;
    //     // 不需要标黄的字符串截取的片段
    //     if (item.end <= itemdata.title.length) {
    //       item.start = item.start;
    //       item.end = item.end;
    //     } else {
    //       item.start = item.start - 1 - itemdata.title.length;
    //       item.end = item.end - 1 - itemdata.title.length;
    //     }
    //     strArr.push(text.substring(indexTemp, item.start));
    //     indexTemp = item.end;
    //     if (index + 1 === arr.length) {
    //       strArr.push(text.substring(indexTemp, text.length));
    //     }
    //     const dom = `<span id=red_word_${item.id} class="mark">${item.problemWord}</span>`;
    //     // 替换后dom的数组
    //     replaceArr.push(dom);
    //   });
    //   // 处理后，页面展示的dom字符串
    //   replaceArr.length &&
    //     replaceArr.map((item, index) => {
    //       resultStr += strArr[index] + item;
    //       if (index + 1 === replaceArr.length) {
    //         // 高亮片段数组跟非高亮片段数组长度是否一致，一致取空（高亮在文章结尾时，高亮片段数组跟非高亮片段数组长度一致）
    //         const lastnum = index + 1;
    //         resultStr += lastnum > strArr.length ? "" : strArr[index + 1];
    //       }
    //     });
    //   if (arr.length !== 0) {
    //     return resultStr;
    //   } else {
    //     return "";
    //   }
    // },
    // 判断是否有重复区间，计算合并后的区间
    mergeIntervals(arr) {
      // 清空结果数组
      const mergedArr = [];
      this.mergedarr = [];

      // 深拷贝 arr
      const wordList = JSON.parse(JSON.stringify(arr));

      // 如果 wordList 为空，直接返回空数组
      if (wordList.length === 0) {
        return { mergedArr, isOverlapping: false };
      }

      // 按 start 值排序
      const sortedIntervals = wordList.sort((a, b) => a.start - b.start);
      let currentInterval = sortedIntervals[0];

      // 遍历所有区间
      for (let i = 1; i < sortedIntervals.length; i++) {
        const nextInterval = sortedIntervals[i];

        // 检查当前区间是否与下一个区间重叠
        if (
          currentInterval.end > nextInterval.start &&
          currentInterval.end <= nextInterval.end
        ) {
          // 有重叠，更新当前区间的 end 值
          currentInterval.end = Math.max(currentInterval.end, nextInterval.end);
        } else {
          // 没有重叠，将当前区间添加到结果数组
          mergedArr.push({
            start: currentInterval.start,
            end: currentInterval.end,
          });
          // 更新当前区间为下一个区间
          currentInterval = nextInterval;
        }
      }

      // 添加最后一个区间到结果数组
      mergedArr.push({
        start: currentInterval.start,
        end: currentInterval.end,
      });

      // 判断是否有重叠区间
      const isOverlapping = mergedArr.length < wordList.length;

      this.mergedarr = mergedArr;

      return { mergedArr, isOverlapping };
    },
    // 查询重叠的字在content中的下标
    queryMarkIndexes(wordList) {
      const markIndexes = new Set(); // 使用 Set 来去重
      const marked = {}; // 用于标记的对象
      wordList.forEach((item) => {
        for (let i = item.start; i <= item.end; i++) {
          markIndexes.add(i); // 添加索引
          marked[i] = i === item.start; // 如果等于 start，标记为 true
        }
      });
      // 生成去重后的数组
      const newarr = Array.from(markIndexes);
      // 用于存储带标记的索引，将标记结果转换为数组
      const markedIndexes = newarr.map((index) => ({
        index: index,
        flag: marked[index] || false, // 如果是 start 的位置，flag 为 true，否则为 false
      }));
      return markedIndexes;
    },
    // 正文非重叠数据标黄
    markYellowNew(resObj) {
      const title = resObj.title;
      const content = resObj.content;
      // 下标小于等于标题长度，高亮在标题，大于-高亮在正文中
      const titlearr = resObj.wordList.filter(
        (item) => item.end <= resObj.title.length
      );
      const contentarr = resObj.wordList.filter(
        (item) => item.end > resObj.title.length
      );
      const titlefilter = Array.from(
        resObj.title.replace(/(\r\n|\r|\n)+/g, "")
      );
      const contentfilter = Array.from(
        resObj.content.replace(/(\r\n|\r|\n)+/g, "")
      );
      this.articleTitle =
        titlearr.length > 0 ? this.markTitle(titlearr, titlefilter) : title;
      this.articleContent =
        contentarr.length > 0
          ? this.markContent(contentarr, contentfilter, resObj)
          : content;
    },
    markTitle(titlearr, titlefilter) {
      // 按start位置降序排列，从后往前替换，避免索引位置变化影响
      const sortedArr = [...titlearr].sort((a, b) => b.start - a.start);

      // 先将数组转换为字符串进行处理
      let result = titlefilter.join("");

      sortedArr.forEach((item) => {
        const { start, end, problemWord } = item;
        const realStart = start;
        const realEnd = end;
        const markElement = `<span class="mark" id=red_word_${realStart}>${problemWord}</span>`;
        result =
          result.substring(0, realStart) +
          markElement +
          result.substring(realEnd);
      });

      return result;
    },
    markContent(contentarr, contentfilter, resObj) {
      // 按start位置降序排列，从后往前替换，避免索引位置变化影响
      const sortedArr = [...contentarr].sort((a, b) => b.start - a.start);

      console.log("-----------sortedArr----------");
      console.log(sortedArr);

      const realTitle = resObj.title.replace(/(\r\n|\r|\n)+/g, "");

      // 先将数组转换为字符串进行处理
      let result = contentfilter.join("");

      sortedArr.forEach((item) => {
        const { start, end, problemWord } = item;
        const realStart = start - realTitle.length - 1;
        const realEnd = end - realTitle.length - 1;
        const markElement = `<span class="mark" id=red_word_${start}>${problemWord}</span>`;
        result =
          result.substring(0, realStart) +
          markElement +
          result.substring(realEnd);
      });

      return result;
    },
    // 正文重叠数据 - 标黄
    handlerTitleOrContent(resObj) {
      const titleLength = resObj.title.length;
      // 根据resObj.wordList的下标，区分出是title 和 content 的标黄区间
      const titlearr =
        resObj.wordList.filter((item) => item.end <= titleLength) || [];
      const contentarr =
        resObj.wordList.filter((item) => item.end > titleLength) || [];

      const titleIndexarr = this.handlerRealIndexs(
        titlearr,
        titleLength,
        false
      );
      const contentIndexarr = this.handlerRealIndexs(
        contentarr,
        titleLength,
        true
      );

      const titlefilter = Array.from(
        resObj.title.replace(/(\r\n|\r|\n)+/g, "")
      );
      const contentfilter = Array.from(
        resObj.content.replace(/(\r\n|\r|\n)+/g, "")
      );

      this.articleTitle = titlearr.length
        ? this.markedTags(titleIndexarr, titlefilter, false, titleLength)
        : resObj.title;
      this.articleContent = contentarr.length
        ? this.markedTags(contentIndexarr, contentfilter, true, titleLength)
        : resObj.content;
    },
    // 正文重叠数据 - 处理title和content的下标，获取真实下标位置
    handlerRealIndexs(wordList, titleLength, isContent = false) {
      // 过滤 wordList，根据是否是 content 进行调整
      const filteredWordList = wordList.map((item) => {
        item.startCopy = JSON.parse(JSON.stringify(item.start));
        if (isContent && item.end > titleLength) {
          return {
            start: item.start - titleLength - 1, // 调整 start
            end: item.end - titleLength - 2, // 调整 end
            startCopy: JSON.parse(JSON.stringify(item.start)),
            endCopy: JSON.parse(JSON.stringify(item.end)),
          };
        } else {
          return {
            start: item.start, // 调整 start
            end: item.end - 1, // 调整 end
            startCopy: JSON.parse(JSON.stringify(item.start)),
            endCopy: JSON.parse(JSON.stringify(item.end)),
          };
        }
      });

      const markIndexes = this.queryMarkIndexes(filteredWordList);

      return markIndexes;
    },
    // 正文重叠数据 - 标黄
    markedTags(dataarr, textarr, isContent, titleLength) {
      // 用于存放最终结果
      let result = [...textarr];
      dataarr.forEach((ele) => {
        if (ele.index >= 0 && ele.index < result.length) {
          // 确保索引在范围内
          const realId = isContent
            ? Number(ele.index) + Number(titleLength) + 1
            : ele.index;
          const spanId = `red_word_${realId}`;
          const spanClass = "mark";
          const spanElement = `<span class="${spanClass}" ${
            ele.flag ? ` id="${spanId}"` : ""
          }>${result[ele.index]}</span>`;
          result[ele.index] = spanElement;
        }
      });
      // 将数组转换为字符串并返回
      return result.join("");
    },
    //..............
    // 检查附件和ocr错词范围的有效性
    setTrueInRange(arr, start, end, id) {
      start *= 1;
      end *= 1;
      if (start < 0 || end > arr.length || start > end) {
        console.error("无效的范围：", { start, end });
        return;
      }
      for (let i = start; i < end; i++) {
        arr[i] = [true, id];
      }
    },
    // 锚点定位（ocr、att错词定位）
    positioning(item) {
      if (item.id) {
        document.getElementById("red_word_" + item.id).scrollIntoView({
          behavior: "smooth", // 平滑过渡
          block: "center", // 上边框与视窗顶部平齐。默认值
        });
      }
    },
		// 锚点定位(标题、正文错词定位)
		positionAct(item) {
			  console.log(item.start);
				
				// 固定表述错误
				document.getElementById('red_word_' + item.start).scrollIntoView({
					behavior: 'smooth', // 平滑过渡
					block: 'center' // 上边框与视窗顶部平齐。默认值
				})
		},
    closeMask() {
      this.isShowIgnore = false;
      this.isShowDispose = false;
      this.activeIgnore = "";
      this.activeDispose = "";
    },
    ignoreInfo() {
      this.isShowIgnore = true;
      this.isShowDispose = false;
    },
    ignoreHandler(data) {
      this.activeIgnore = data.value;
      this.violationInfo(this.activeIgnore, "忽略");
    },
    disposeInfo() {
      this.isShowIgnore = false;
      this.isShowDispose = true;
    },
    disposeHandler(data) {
      this.activeDispose = data.value;
      this.violationInfo(this.activeDispose, "处置");
    },
    violationInfo(status, txt) {
      Toast.loading({
        message: "处置中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      handleViolation({
        desc: "",
        handleStatus: status,
        data: [
          {
            violationType: 1,
            id: this.resObj.id,
            publishTime: this.resObj.publishTime,
          },
        ],
      })
        .then((res) => {
          if (res.data.code === 200) {
            setTimeout(function () {
              Toast.success({
                message: txt + "信息成功",
              });
              window.location.reload();
            }, 300);
          } else {
            setTimeout(function () {
              Toast.error({
                message: txt + "信息失败",
              });
              window.location.reload();
            }, 300);
          }
        })
        .catch((err) => {
          Toast.clear();
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import url("./fixedstatementerror.css");
</style>
